export enum AnalyticsEventNames {
    consecutive_losses = 'consecutive_losses',

    moves_left = 'moves_left',

    shortcut_show = 'shortcut_show',
    shortcut_create = 'shortcut_create',
    shortcut_deny = 'shortcut_deny',

    no_lives = 'no_lives',

    coins_on_chapter_start = 'coins_on_chapter_start',

    reset_progress = 'reset_progress',

    solve_time = 'solve_time',
    lose_time = 'lose_time',

    levelsInSession = 'levelsInSession',
    sessionDuration = 'sessionDuration',

    rewarded_request = 'rewarded_request_',
    rewarded_show = 'rewarded_show_',
    rewarded_impression = 'rewarded_impression_',
    rewarded_fail = 'rewarded_fail_',

    interstitial_request = 'interstitial_request_',
    interstitial_show = 'interstitial_show_',
    interstitial_impression = 'interstitial_impression_',
    interstitial_fail = 'interstitial_fail_',

    reward_gift_collected = 'reward_gift_collected',
    continue_used = 'continue_used',
    passed_MPS = 'passed_MPS',
    start_over = 'start_over',
    share_end_chapter = 'share_end_chapter',
    ads_throttled = 'ads_throttled',

    no_ads_purchase_attempt = 'no_ads_purchase_attempt',
    no_ads_purchase_fail = 'no_ads_purchase_fail',
    no_ads_purchase_success = 'no_ads_purchase_success',

    context_type = 'context_type',
    bot_subscribe_success = 'bot_subscribe_success',
    bot_subscribe_fail = 'bot_subscribe_fail',
    banner_ad_shown = 'banner_ad_shown',

    invite_attempt = 'invite_attempt',
    invite_source = 'invite_source_',
}
